module.exports = __webpack_public_path__ + "img/shot_img112501.a400781e.gif";